import { render, staticRenderFns } from "./communicationDashboardCompetition.vue?vue&type=template&id=1fa65070&scoped=true"
import script from "./communicationDashboardCompetition.vue?vue&type=script&lang=js"
export * from "./communicationDashboardCompetition.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardCompetition.vue?vue&type=style&index=0&id=1fa65070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa65070",
  null
  
)

export default component.exports